"use client";

import Image from "next/image";
import Link from "next/link";
import { ArrowRight } from "lucide-react";

export default function AwardCard() {

    return (
        <div className="relative group">

            {/* Full clickable overlay */}
            <Link href="#" className="absolute inset-0 z-40 w-full h-full"/>

            {/* Image Container */}
            <div className="aspect-[1.423] flex justify-center items-center rounded-[25px] relative">

                {/* Image Wrapper with hover zoom */}
                <div className="overflow-hidden absolute inset-0 rounded-[25px]">
                    <Image src="/images/blogs.jpg" alt="Enterprise Awards 2024 - Winner" fill 
                        className="object-cover rounded-[25px] transition-transform duration-300 ease-in group-hover:scale-110"
                    />
                </div>

                {/* Corner Button Block */}
                <div className="absolute -bottom-px -right-px bg-white w-[80px] h-[80px] flex justify-end items-end z-10 rounded-tl-[25px]
                before:content-[''] before:w-[29px] before:h-px before:bg-white before:absolute before:right-[25px] before:top-0
                after:content-[''] after:h-[29px] after:w-px after:bg-white after:absolute after:left-0 after:bottom-[25px]"
                >
                    <Link href="#"
                        className="relative z-10 w-[68px] aspect-square flex items-center justify-center bg-primary rounded-[14px] transition-all duration-300 ease-in 
                                    group-hover:bg-secondary"
                        >
                        <ArrowRight className="w-6 h-6 text-white transition-transform duration-300 ease-in group-hover:scale-125"
                        />
                    </Link>

                    {/* SVG corner shapes */}
                    <svg className="absolute -top-[25px] right-0" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 25.7H26V0C24.9371 13.7891 13.7959 24.7289 0 25.7Z" className="fill-white" />
                        <path d="M0 25.25H0.5C14.3071 25.25 25.5 13.8071 25.5 0V0" className="stroke-white" />
                    </svg>

                    <svg className="absolute -top-[0] -left-[0] rotate-180" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 25.7H26V0C24.9371 13.7891 13.7959 24.7289 0 25.7Z" className="fill-none" />
                        <path d="M0 25.25H0.5C14.3071 25.25 25.5 13.8071 25.5 0V0" className="stroke-[#E2E2E2]" />
                    </svg>

                    <svg className="absolute bottom-0 -left-[25px]" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path className="fill-white" d="M0,26h26V0C24.9,14,13.8,25,0,26Z"></path>
                        <path className="stroke-white" d="M0,25.5h.5c13.8,0,25-11.6,25-25.5h0"></path>
                    </svg>

                </div>

            </div>

            {/* Title */}
            <h4 className="text-[22px] mt-[12px] sm:mt-[26px] text-black pr-[80px] font-medium leading-snug">
                HFM EU Services Awards 2024: Best Technology Firm – Overall
            </h4>

        </div>
    );
}
